const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

function startOfLocalDay(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/**
 * Relative time labels in pt-BR for notification hubs.
 * Examples: "Agora", "há 5 min", "há 1 h", "Ontem", "há 3 dias"
 */
export function formatRelativeTime(isoDate: string, now = new Date()): string {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = now.getTime() - date.getTime();
  if (diffMs < 0) return 'Agora';

  if (diffMs < MINUTE_MS) return 'Agora';

  const minutes = Math.floor(diffMs / MINUTE_MS);
  if (minutes < 60) return `há ${minutes} min`;

  const hours = Math.floor(diffMs / HOUR_MS);
  if (hours < 24) return `há ${hours} h`;

  const todayStart = startOfLocalDay(now);
  const yesterdayStart = new Date(todayStart.getTime() - DAY_MS);
  if (date >= yesterdayStart && date < todayStart) return 'Ontem';

  const days = Math.floor(diffMs / DAY_MS);
  if (days < 7) return `há ${days} dias`;

  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
  });
}
